import React, { useState } from 'react';
import EventCard from './eventcard';
import Modal from 'react-modal';
import '../styles/eventsection.css';
import SubNav from './subNav';
import { 
  addDays, 
  eachDayOfInterval, 
  endOfMonth, 
  format, 
  startOfMonth, 
  getDay 
} from 'date-fns';
import { baseUrl } from '../config';

Modal.setAppElement('#root');



const EventsSection = () => {
  const [events, setEvents] = useState([
    { id: 1, taskName: 'Task 1', time: '12:00-4:00', description: 'Task 1 description', date: '2024-08-26' },
    { id: 2, taskName: 'Task 2', time: '12:00-4:00', description: 'Task 2 description', date: '2024-08-27' },
    { id: 3, taskName: 'Task 3', time: '12:00-4:00', description: 'Task 3 description', date: '2024-08-28' },
    { id: 4, taskName: 'Task 4', time: '12:00-4:00', description: 'Task 4 description', date: '2024-08-29' }
  ]);

  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  
  const [newTask, setNewTask] = useState({ taskName: '', time: '', description: '', date: '' });
  const [currentTask, setCurrentTask] = useState(null);

  // Calendar State
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const [showForm, setShowForm] = useState(false);
  const [timelineData, setTimelineData] = useState([
    { task: 'Script Breakdowns', days: 5, start: 3, color: 'bg-red-600' },
    { task: 'Finalize Script', days: 3, start: 1, color: 'bg-pink-500' },
    { task: 'Location Scouting', days: 5, start: 5, color: 'bg-gray-500' },
    { task: 'Shot Lists', days: 6, start: 10, color: 'bg-yellow-600' },
    { task: 'Shooting Schedule', days: 4, start: 15, color: 'bg-green-500' },
    { task: 'Casting', days: 3, start: 19, color: 'bg-blue-700' },
    { task: 'Rehearsals', days: 2, start: 22, color: 'bg-teal-600' },
    { task: 'Shooting', days: 3, start: 24, color: 'bg-purple-600' },
    { task: 'Post-production', days: 4, start: 27, color: 'bg-purple-600' },
  ]);
  const [taskDetails, setTaskDetails] = useState({
    task: '',
    startDate: '',
    days: '',
    color: 'bg-red-600',
  });

  const colorOptions = [
    'bg-red-600', 'bg-pink-500', 'bg-gray-500', 'bg-yellow-600', 
    'bg-green-500', 'bg-blue-700', 'bg-teal-600', 'bg-purple-600'
  ];

  // Get today's date in 'YYYY-MM-DD' format
  const today = new Date().toISOString().split('T')[0];

  // Separate today's events and upcoming events
  const todayEvents = events.filter(event => event.date === today);
  const upcomingEvents = events.filter(event => event.date > today);

  // Calendar functions
  const startDate = startOfMonth(new Date(selectedYear, selectedMonth));
  const endDate = endOfMonth(startDate);
  const dates = eachDayOfInterval({ start: startDate, end: endDate });
  
  // Calculate calendar grid
  const firstDayOfMonth = getDay(startDate);
  const totalDays = dates.length;
  const totalWeeks = Math.ceil((totalDays + firstDayOfMonth) / 7);
  
  const getDayTasks = (date) => {
    const dayOfMonth = parseInt(format(date, 'd'));
    return timelineData.filter(task => {
      const taskStart = task.start;
      const taskEnd = task.start + task.days - 1;
      return dayOfMonth >= taskStart && dayOfMonth <= taskEnd;
    });
  };

  // Event handlers for tasks
  const handleAddTaskClick = () => {
    setNewTask({ taskName: '', time: '', description: '', date: today });
    setIsAddModalOpen(true);
  };

  const handleEditTaskClick = (task) => {
    setCurrentTask(task);
    setNewTask({ taskName: task.taskName, time: task.time, description: task.description, date: task.date });
    setIsEditModalOpen(true);
  };

  const handleViewTaskClick = (task) => {
    setCurrentTask(task);
    setIsViewModalOpen(true);
  };

  const handleDeleteTaskClick = (id) => {
    setEvents(events.filter(task => task.id !== id));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewTask(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSaveTask = () => {
    if (newTask.taskName && newTask.time && newTask.date) {
      if (isEditModalOpen && currentTask) {
        setEvents(events.map(task =>
          task.id === currentTask.id ? { ...task, ...newTask } : task
        ));
      } else {
        setEvents([...events, { ...newTask, id: events.length + 1 }]);
      }
      closeAllModals();
    }
  };

  const closeAllModals = () => {
    setIsAddModalOpen(false);
    setIsEditModalOpen(false);
    setIsViewModalOpen(false);
    setNewTask({ taskName: '', time: '', description: '', date: '' });
    setCurrentTask(null);
  };

  // Calendar handlers
  const handleYearChange = (e) => setSelectedYear(Number(e.target.value));
  const handleMonthChange = (e) => setSelectedMonth(Number(e.target.value));

  const handleCalendarInputChange = (e) => {
    const { name, value } = e.target;
    setTaskDetails({ ...taskDetails, [name]: value });
  };

  const handleAddCalendarTask = (e) => {
    e.preventDefault();

    const startDateObject = new Date(taskDetails.startDate);
    const startOfMonthDate = startOfMonth(new Date(selectedYear, selectedMonth));
    const startDay = Math.ceil((startDateObject - startOfMonthDate) / (1000 * 60 * 60 * 24)) + 1;

    if (startDay < 1 || startDay > endDate.getDate()) {
      alert('Task start date must be within the selected month.');
      return;
    }

    const newTask = {
      ...taskDetails,
      task: taskDetails.task,
      start: startDay,
      days: parseInt(taskDetails.days, 10),
      color: taskDetails.color,
    };

    setTimelineData([...timelineData, newTask]);
    setShowForm(false);
    setTaskDetails({
      task: '',
      startDate: '',
      days: '',
      color: colorOptions[0],
    });
  };

  return (
    <>
      <SubNav/>
      <div className="events-section">
        <div className="events-today">
          <div className="header">
            <h2>TODAY'S EVENTS</h2>
            <button className="add-task-btn" onClick={handleAddTaskClick}>
              + Add Task
            </button>
          </div>
          <div className="events-grid">
            {todayEvents.map(event => (
              <EventCard 
                key={event.id} 
                taskName={event.taskName} 
                time={event.time} 
                description={event.description}
                onView={() => handleViewTaskClick(event)}
                onEdit={() => handleEditTaskClick(event)}
                onDelete={() => handleDeleteTaskClick(event.id)}
              />
            ))}
          </div>
        </div>

        <div className="events-upcoming">
          <div className="header">
            <h2>UPCOMING EVENTS</h2>
          </div>
          <div className="events-grid">
            {upcomingEvents.map(event => (
              <EventCard 
                key={event.id} 
                taskName={event.taskName} 
                time={event.time} 
                description={event.description}
                onView={() => handleViewTaskClick(event)}
                onEdit={() => handleEditTaskClick(event)}
                onDelete={() => handleDeleteTaskClick(event.id)}
              />
            ))}
          </div>
        </div>

        {/* Calendar Section */}
        <div className="calendar-section mt-8">
          <div className="header">
            <h2>CALENDAR VIEW</h2>
          </div>
          
          <div className="flex justify-center p-3 mb-4 space-x-4">
            <select 
              value={selectedYear} 
              onChange={handleYearChange} 
              className="p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              {[2023, 2024, 2025, 2026].map((year) => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
            <select 
              value={selectedMonth} 
              onChange={handleMonthChange} 
              className="p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              {[
                'January', 'February', 'March', 'April', 'May', 'June', 'July',
                'August', 'September', 'October', 'November', 'December'
              ].map((month, index) => (
                <option key={index} value={index}>{month}</option>
              ))}
            </select>
            <button 
              onClick={() => setShowForm(!showForm)} 
              className="p-2 bg-blue-600 text-white rounded"
            >
              {showForm ? 'Cancel' : 'Add Task'}
            </button>
          </div>

          {/* Calendar Grid */}
          <div className="border rounded-lg shadow">
            <div className="grid grid-cols-7 gap-0 bg-gray-100 font-semibold border-b">
              {['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].map((day) => (
                <div key={day} className="p-2 text-center border-r last:border-r-0">
                  {day}
                </div>
              ))}
            </div>
            <div className="grid grid-cols-7 gap-0">
              {Array.from({ length: totalWeeks * 7 }).map((_, index) => {
                const currentDate = addDays(startDate, index - firstDayOfMonth);
                const isCurrentMonth = format(currentDate, 'M') === format(startDate, 'M');
                const dayTasks = isCurrentMonth ? getDayTasks(currentDate) : [];

                return (
                  <div
                    key={index}
                    className={`min-h-24 p-1 border-r border-b relative ${
                      isCurrentMonth ? 'bg-white' : 'bg-gray-50'
                    }`}
                  >
                    <div className="text-right p-1">
                      <span className={`${isCurrentMonth ? 'text-gray-900' : 'text-gray-400'}`}>
                        {format(currentDate, 'd')}
                      </span>
                    </div>
                    <div className="space-y-1">
                      {dayTasks.map((task, idx) => (
                        <div
                          key={idx}
                          className={`${task.color} text-white text-xs p-1 rounded truncate`}
                          title={task.task}
                        >
                          {task.task}
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Add Task Modal */}
        <Modal
          isOpen={isAddModalOpen}
          onRequestClose={closeAllModals}
          contentLabel="Add Task"
          className="add-task-modal"  
          overlayClassName="modal-overlay"
        >
          <h2>Add New Task</h2>
          <input
            type="text"
            name="taskName"
            value={newTask.taskName}
            onChange={handleInputChange}
            placeholder="Title"
          />
          <input
            type="text"
            name="time"
            value={newTask.time}
            onChange={handleInputChange}
            placeholder="Time (e.g., 12:00-4:00)"
          />
          <textarea
            name="description"
            value={newTask.description}
            onChange={handleInputChange}
            placeholder="Description"
          />
          <input
            type="date"
            name="date"
            value={newTask.date}
            onChange={handleInputChange}
          />
          <button className="save-btn" onClick={handleSaveTask}>
            Save
          </button>
          <button className="close-btn" onClick={closeAllModals}>Cancel</button>
        </Modal>

        {/* Edit Task Modal */}
        <Modal
          isOpen={isEditModalOpen}
          onRequestClose={closeAllModals}
          contentLabel="Edit Task"
          className="edit-task-modal"  
          overlayClassName="modal-overlay"  
        >
          <h2>Edit Task</h2>
          <input
            type="text"
            name="taskName"
            value={newTask.taskName}
            onChange={handleInputChange}
            placeholder="Title"
          />
          <input
            type="text"
            name="time"
            value={newTask.time}
            onChange={handleInputChange}
            placeholder="Time (e.g., 12:00-4:00)"
          />
          <textarea
            name="description"
            value={newTask.description}
            onChange={handleInputChange}
            placeholder="Description"
          />
          <input
            type="date"
            name="date"
            value={newTask.date}
            onChange={handleInputChange}
          />
          <button className="save-btn" onClick={handleSaveTask}>
            Save
          </button>
          <button className="close-btn" onClick={closeAllModals}>Cancel</button>
        </Modal>

        {/* View Task Modal */}
        <Modal
          isOpen={isViewModalOpen}
          onRequestClose={closeAllModals}
          contentLabel="View Task"
          className="view-task-modal"  
          overlayClassName="modal-overlay"  
        >
          <h2>{currentTask?.taskName}</h2>
          <p><strong>Time:</strong> {currentTask?.time}</p>
          <p><strong>Description:</strong> {currentTask?.description}</p>
          <p><strong>Date:</strong> {currentTask?.date}</p>
          <button className="close-btn" onClick={closeAllModals}>Close</button>
        </Modal>

        {/* Add Calendar Task Form Modal */}
        {showForm && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded shadow-lg w-1/3">
              <h2 className="text-lg font-bold mb-4">Add New Calendar Task</h2>
              <form onSubmit={handleAddCalendarTask}>
                <div className="flex flex-col space-y-2">
                  <input
                    type="text"
                    name="task"
                    value={taskDetails.task}
                    onChange={handleCalendarInputChange}
                    className="p-2 border rounded"
                    placeholder="Task name"
                    required
                  />
                  <input
                    type="date"
                    name="startDate"
                    value={taskDetails.startDate}
                    onChange={handleCalendarInputChange}
                    className="p-2 border rounded"
                    required
                  />
                  <input
                    type="number"
                    name="days"
                    value={taskDetails.days}
                    onChange={handleCalendarInputChange}
                    placeholder="Number of Days"
                    className="p-2 border rounded"
                    min="1"
                    required
                  />
                  <select
                    name="color"
                    value={taskDetails.color}
                    onChange={handleCalendarInputChange}
                    className="p-2 border rounded"
                  >
                    {colorOptions.map((color) => (
                      <option key={color} value={color}>
                        {color}
                      </option>
                    ))}
                  </select>
                  <button type="submit" className="p-2 bg-green-600 text-white rounded">
                    Add Task
                  </button>
                  <button
                    type="button"
                    onClick={() => setShowForm(false)}
                    className="p-2 bg-red-600 text-white rounded"
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default EventsSection;
